import { learners } from './learners';
import { trainingCampaigns } from './trainingCampaigns';
import { trainingModules } from './trainingModules';
import { complianceRecords } from './complianceRecords';
import { incidentEvents } from './incidentEvents';

export const getLearnerById = (id) => learners.find((l) => l.id === id) || null;
export const getLearnerFullName = (id) => {
  const l = getLearnerById(id);
  return l ? `${l.firstName} ${l.lastName}` : 'Unknown';
};
export const getCampaignById = (id) => trainingCampaigns.find((c) => c.id === id) || null;
export const getModuleById = (id) => trainingModules.find((m) => m.id === id) || null;
export const getComplianceByLearner = (learnerId) => complianceRecords.filter((r) => r.learnerId === learnerId);
export const getIncidentsByLearner = (learnerId) => incidentEvents.filter((e) => e.learnerId === learnerId);

export const getRiskLevel = (score) => {
  if (score < 20) return { label: 'Low', color: 'bg-emerald-50 text-emerald-700 border-emerald-200' };
  if (score < 50) return { label: 'Medium', color: 'bg-amber-50 text-amber-700 border-amber-200' };
  return { label: 'High', color: 'bg-red-50 text-red-700 border-red-200' };
};

export const getStatusColor = (status) => {
  switch (status) {
    case 'Compliant': return 'bg-emerald-50 text-emerald-700 border-emerald-200';
    case 'Completed': return 'bg-emerald-50 text-emerald-700 border-emerald-200';
    case 'In Progress': return 'bg-blue-50 text-blue-700 border-blue-200';
    case 'Active': return 'bg-blue-50 text-blue-700 border-blue-200';
    case 'Overdue': return 'bg-amber-50 text-amber-700 border-amber-200';
    case 'At Risk': return 'bg-amber-50 text-amber-700 border-amber-200';
    case 'Not Started': return 'bg-slate-50 text-slate-600 border-slate-200';
    case 'Draft': return 'bg-slate-50 text-slate-600 border-slate-200';
    default: return 'bg-slate-50 text-slate-600 border-slate-200';
  }
};

export const getEventTypeColor = (type) => {
  switch (type) {
    case 'Phishing Click': return 'bg-amber-50 text-amber-700 border-amber-200';
    case 'Credential Submission': return 'bg-red-50 text-red-700 border-red-200';
    case 'Phishing Report': return 'bg-emerald-50 text-emerald-700 border-emerald-200';
    case 'Training Not Started': return 'bg-slate-50 text-slate-600 border-slate-200';
    default: return 'bg-slate-50 text-slate-600 border-slate-200';
  }
};

export const getSummaryMetrics = () => {
  const total = learners.length;
  const compliant = complianceRecords.filter(r => r.complianceStatus === 'Compliant').length;
  const avgRisk = Math.round(learners.reduce((a, b) => a + b.phishingRiskScore, 0) / total);
  const activeCampaigns = trainingCampaigns.filter(c => c.status === 'Active').length;
  const avgCompletion = Math.round(
    trainingCampaigns.filter(c => c.status === 'Active')
      .reduce((a, b) => a + b.completionRate, 0) / trainingCampaigns.filter(c => c.status === 'Active').length
  );
  return { total, compliant, avgRisk, activeCampaigns, avgCompletion };
};